import { AppTab } from '@freight-cbm/shared-types';

interface TabBarProps {
  activeTab: AppTab;
  onTabChange: (tab: AppTab) => void;
}

const tabs: { key: AppTab; label: string }[] = [
  { key: 'calculator', label: 'Calculator' },
  { key: 'optimization', label: 'Optimization' },
  { key: 'reference', label: 'Reference' },
  { key: 'history', label: 'History' },
];

export function TabBar({ activeTab, onTabChange }: TabBarProps) {
  return (
    <nav
      role="tablist"
      aria-label="Main navigation"
      style={{
        display: 'flex',
        height: 'var(--tab-bar-height)',
        borderBottom: '1px solid var(--color-border)',
        background: 'var(--color-bg-primary)',
        overflowX: 'auto',
      }}
    >
      {tabs.map((tab) => (
        <button
          type="button"
          key={tab.key}
          role="tab"
          aria-selected={activeTab === tab.key}
          aria-controls={`panel-${tab.key}`}
          id={`tab-${tab.key}`}
          onClick={() => {
            onTabChange(tab.key);
            // R11: Move focus to the panel content after tab switch
            requestAnimationFrame(() => {
              document.getElementById(`panel-${tab.key}`)?.focus();
            });
          }}
          style={{
            flex: 1,
            padding: '0 var(--space-4)',
            border: 'none',
            background: 'transparent',
            color: activeTab === tab.key ? 'var(--color-accent)' : 'var(--color-text-secondary)',
            fontWeight: activeTab === tab.key ? 'var(--font-weight-semibold)' : 'var(--font-weight-medium)',
            fontSize: 'var(--font-size-sm)',
            borderBottom: activeTab === tab.key ? '3px solid var(--color-accent)' : '3px solid transparent',
            cursor: 'pointer',
            transition: 'color var(--transition-fast), border-color var(--transition-fast), background var(--transition-fast)',
            minWidth: 'fit-content',
            minHeight: 'var(--touch-target)',
          }}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
